export default __webpack_public_path__ + "static/media/package.55598bd0.png";